import { CMDInitBet } from "./CMDInitBet"
import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDSpInitNbsBet implements ICommand
{

	public GameID : number = 0;
	public betFormat : number = 0;
	public betSeqID : number = 0;
	public Bet : Array<CMDInitBet>;

	public constructor()
	{
		this.Bet = new Array<CMDInitBet>();
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.GameID = ba.readInt53();
		this.betFormat = ba.readUint16();
		this.betSeqID = ba.readUint53();
		let BetSize:number = ba.readUint8();
		while (BetSize-- > 0)
		{
			let BetChild:CMDInitBet = new CMDInitBet();
			BetChild.fromBytes(ba);
			this.Bet.push(BetChild);
		}
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint53(this.GameID);
		ba.writeUint16(this.betFormat);
		ba.writeUint53(this.betSeqID);
		ba.writeUint8(this.Bet.length);
		for (const BetChild of this.Bet)
		{
			let tempBuf = BetChild.toBytes();
			ba.appendBuf(tempBuf.toBuffer());
		}

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDSpInitNbsBet();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'GameID(Q)='+this.GameID+' ';
		str += 'betFormat(W)='+this.betFormat+' ';
		str += 'betSeqID(Q)='+this.betSeqID+' ';
		str += 'Bet_size(B)='+this.Bet.length + ' ';
		str += 'Bet(CMDInitBet)=[';
		for (let BetChild in this.Bet)
		{
			if (<number><unknown>BetChild > 0) str += ', ';
			str += this.Bet[BetChild].toString();
		}
		str += '] ';
		return str;
	}

	public getCmdID() : number
	{
		return 50129;
	}

	public getCmdName() : string
	{
		return 'SpInitNbsBet';
	}

}
